import { pick } from "lodash";
import * as requestFromServer from "./ordersCrud";
import { ordersSlice, callTypes } from "./ordersSlice";
import { ORDER_STATUS } from "./../../../Common/constants/index";
import { notification } from "antd";
import { handleApiErrorResponse } from "../../../../modules/Common/utils";

const { actions } = ordersSlice;

// fetched products
export const fetchProducts = (queryParams, isTaxEnabled) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  dispatch(actions.resetList());

  return requestFromServer
    .findOptimizedProductsForSale(queryParams, isTaxEnabled)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.productsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};
export const JreRenderList = (payload) => (dispatch) => {
  dispatch(actions.JreRenderList(true));
  setTimeout(() => {
    dispatch(actions.JreRenderList(false));
  }, 0);
};

export const createOrderReturn = (order, edited) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createOrderReturn(order, edited)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(actions.orderReturning({ message, entity }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

// create order
export const createOrder = (order, f, history, errorFn, public_key) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .createOrder(order)
    .then((response) => {
      !!f && f();
      const { message, entity } = response.data;
      if (entity.requires_action) {
        dispatch(actions.orderRequiresAction({ message, entity }));
      } else {
        const park = order.is_parked ? true : false;
        dispatch(actions.orderCreated({ message, entity, park }));
        dispatch(actions.removeCustomer());
        if (!(entity?.status === ORDER_STATUS.PARKED.value) && entity?.peculiar_no && history) {
          history.push(`/sale/invoice/${entity?.peculiar_no}?pk=${public_key}`);
        } else {
          history.push("/sale/history");
        }
      }
    })
    .catch((error) => {
      errorFn(error);
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

//change order complete status
export const changeCompleteStatus = (status) => (dispatch) => {
  dispatch(actions.changeCompleteStatus({ status }));
};
export const resetOrder = (status) => (dispatch) => {
  dispatch(actions.resetOrder());
};

// update order :update parked order

export const updateOrder = (orderId, order, history, public_key, handleSubmitState, handleSideEffects) => (dispatch) => {
  let pickListArgs = [
    "sale_order_details",
    "discount",
    "discount_type",
    "additional_attributes",
    "sale_type",
    "sale_rep_id",
    "commission_to_sale_rep",
    "delivery_charges",
    "customer_id",
    "coupon_number",
    "order_type",
    "other_type_value",
    "payment_date",
    "payment_type",
    "pickup_delivery_date",
    "shipping_type",
    "is_parked",
    "is_picked_now",
    "due_date",
    "shipping_detail",
    "billing_detail",
    "payment_detail",
    "channel_id",
    "storage_type",
    "delivery_date",
    "dispatch_date",
    "order_date",
    "update_shipping_billing",
    "skip_eligibility_check",
    "no",
    "is_change_status",
    "internal_note",
    "external_note",
    "sale_order_level_tax_ids",
    "msrp_price",
    "is_zero_tax_allowed",
    "preserve_prices",
    "tag_ids",
    "department_allocations"
  ];
  const argsListing = order.sale_type === 2 ? [...pickListArgs, "parent_id"] : pickListArgs;
  let Order = {
    ...pick(order, [...argsListing, `${!!order?.is_parked ? "park_note" : "id"}`]),
  };
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .updateOrder(orderId, Order)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(actions.removeCustomer());
      if (entity.requires_action) {
        dispatch(actions.orderRequiresAction({ message, entity }));
      } else {
        dispatch(actions.orderCreated({ message, entity, park: Order.is_parked }));
        if (entity?.status === ORDER_STATUS.PARKED.value) {
          history.push(`/sale/history`);
        }
        if (!(entity?.status === ORDER_STATUS.PARKED.value) && entity?.peculiar_no && history) {
          history.push(`/sale/invoice/${entity?.peculiar_no}?pk=${public_key}`);
        }
      }
    })
    .catch((error) => {
      if (error.response.data?.data?.untaxed_products?.length) {
        handleSideEffects(error.response.data?.data?.untaxed_products);
      }

      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    })
    .finally(() => {
      if (handleSubmitState) {
        handleSubmitState(false);
      }
    });
};
//apply coupon on current order :save discount
export const applyCoupon = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .applyCoupon(queryParams)
    .then((response) => {
      const { entity, message } = response.data;
      dispatch(actions.applyCoupon({ entity: entity, message: message }));
    })
    .catch((error) => {
      if (error.response) {
        dispatch(
          actions.applyCoupon({
            message: error.response.data?.errors[0],
          })
        );
      }
      dispatch(actions.exceptionHandlerCleaner());
    });
};
//add payment
export const addPayment = (payload, queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .addPayment(payload)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(
        actions.addPayment({
          entity: entity,
          success: message,
        })
      );
      requestFromServer.findSaleOrder(queryParams).then((respons) => {
        const { totalCount, entities, totalByStatus } = respons?.data || { totalCount: 0, entities: [] };
        dispatch(actions.saleOrdersFetched({ totalCount, entities, totalByStatus }));
      });
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};
//scan product
export const scanProduct = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOptimizedProductsForSale(queryParams)
    .then((response) => {
      const { entities } = response.data;
      dispatch(actions.scanProduct({ entity: entities, queryParams }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};
export const scanOrderDetail = (entities) => (dispatch) => {
  dispatch(actions.searchInSods({ entities }));
};

export const searchInSods = (entities) => (dispatch) => {
  dispatch(actions.searchInSods({ entities }));
};

export const searchOrderDetail = (searchInNotPickedQty) => (dispatch) => {
  dispatch(actions.searchOrderDetail({ entities: searchInNotPickedQty }));
};

//remove coupon applied on cart
export const removeCoupon = () => (dispatch) => {
  dispatch(actions.removeCoupon());
};

// empty order entities
export const emptyOrderEntities = () => (dispatch) => {
  dispatch(actions.emptyOrderEntities());
};

//change tobacco sale eligibility test
export const changeTobaccoSaleEligibilityTest = (skipTobaccoEligibilityTest) => (dispatch) => {
  dispatch(actions.changeTobaccoSaleEligibilityTest({ skipTobaccoEligibilityTest }));
};

export const selectCustomer = (customer, getCustomer) => (dispatch) => {
  return requestFromServer
    .findCustomerById(customer?.id || customer?.item?.id)
    .then((response) => {
      const { entity } = response.data;
      getCustomer && getCustomer(false);
      dispatch(actions.selectCustomer({ customer: { ...entity } }));
    })
    .catch((error) => {
      if (error.response) {
        dispatch(
          actions.updateMessage({
            type: "modalError",
            message: error.response.data.message,
          })
        );
      }
      dispatch(actions.exceptionHandlerCleaner());
    });
};
export const grailPay = (payload) => (dispatch) => {
  dispatch(actions.grailPay(payload));
};
// customer for history
export const selectedCustomerHistory = (customer) => (dispatch) => {
  dispatch(actions.selectedCustomerHistory({ customer }));
};

//deselect customer selected for order
export const removeCustomer = () => (dispatch) => {
  dispatch(actions.removeCustomer());
};

//change value of coupon
export const changeCoupon = (coupon) => (dispatch) => {
  dispatch(actions.changeCoupon({ coupon }));
};

//update message
export const updateMessage = (type, message) => (dispatch) => {
  dispatch(actions.updateMessage({ type, message }));
};
export const removeScanItem = () => (dispatch) => {
  dispatch(actions.removeScanItem());
};

export const setSaleProducts = (searchProducts) => (dispatch) => {
  dispatch(actions.setSaleProducts(searchProducts));
};

export const copyOrder = (id, isCopy) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .getSaleOrderToCopy(id)
    .then((response) => {
      let { entity } = response.data;
      entity.isCopy = isCopy;
      dispatch(
        actions.copyOrder({
          entity: entity,
        })
      );
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

//orders list start
export const fetchOrdersList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findSaleOrder(queryParams)
    .then((response) => {
      const { totalCount, entities, totalByStatus } = response?.data || {
        totalCount: 0,
        entities: [],
        totalByStatus: {},
      };
      dispatch(actions.saleOrdersFetched({ totalCount, entities, totalByStatus }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};
export const fetchFulfillmentList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findSaleFulfillment(queryParams)
    .then((response) => {
      const { totalCount, totalByStatus } = response?.data || {
        totalCount: 0,
        totalByStatus: {},
      };

      let entities = response?.data?.entities || [];

      if (entities.length) {
        // adding _index because backend was giving same record multiple time, it was causing FE to dance. To prevent this we have to add index key to map in the table. We are not having index in the table where we are passing the rowID value
        entities = response?.data?.entities?.map((entity, index) => ({ ...entity, _index: index + 1 }));
      }

      dispatch(actions.saleFulfillmentsFetched({ totalCount, entities, totalByStatus }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

export const changeOrderStatus = (queryParams, params, callback, onPickingModalHide, slug, peculiar_no, publicKey) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .changeOrderStatus(queryParams)
    .then((response) => {
      if (response.status == 200) {
        if (callback) {
          callback(queryParams?.status);
        }
        dispatch(fetchFulfillmentList(params));
        dispatch(
          actions.changeOrderStatus({
            status: "Status Changed Successfully",
          })
        );
        if (slug == "executeOrder") {
          window.open(`/sale/invoice/${peculiar_no}?pk=${publicKey}`, "_blank");
          localStorage.setItem("fromURL", "/sale/fulfillment");
        }

        onPickingModalHide && onPickingModalHide();
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

export const executeSaleOrderDirectly = (infoForExecute, params, callBack, invoiceOpenInfo) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .changeOrderStatus(infoForExecute)
    .then((response) => {
      if (response.status == 200) {
        dispatch(fetchFulfillmentList(params));
        dispatch(
          actions.changeOrderStatus({
            status: "Status Changed Successfully",
          })
        );

        if (invoiceOpenInfo?.slug == "executeOrder") {
          const { peculiar_no, public_key } = invoiceOpenInfo;
          window.open(`/sale/invoice/${peculiar_no}?pk=${public_key}`, "_blank");
          localStorage.setItem("fromURL", "/sale/fulfillment");
        }

        if (callBack) {
          callBack(response.data.entity.status);
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

export const saveOrderTrackingDetails = (queryParams, params, locationState) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .changeOrderStatus(locationState)
    .then((response) => {
      if (response.status == 200) {
        const { to_ship_items } = response.data.entity;
        const { shippingDetails } = queryParams;
        const updatedShippingDetails = { ...shippingDetails, tracking_detail: to_ship_items };
        const updatedQueryParams = { ...queryParams, shippingDetails: { ...updatedShippingDetails, boxes: updatedShippingDetails?.boxes || null } };
        dispatch(
          actions.changeOrderStatus({
            status: "Status Changed Successfully",
          })
        );
        requestFromServer
          .saveTrackingDetails(updatedQueryParams)
          .then((response) => {
            if (response.status == 200) {
              if (locationState?.invoiceOpenInfo?.slug == "executeOrder") {
                console.log("opening info:");
                const { peculiar_no, public_key } = locationState.invoiceOpenInfo;
                window.open(`/sale/invoice/${peculiar_no}?pk=${public_key}`, "_blank");
                localStorage.setItem("fromURL", "/sale/fulfillment");
              }

              dispatch(fetchFulfillmentList(params));
              if (response.data.entity.is_saved) {
                dispatch(
                  actions.changeOrderStatus({
                    status: "Order Tracking Details Saved Successfully",
                  })
                );
              }
            }
          })
          .catch((error) => {
            dispatch(actions.catchError({ error, callType: callTypes.actions }));
            dispatch(actions.exceptionHandlerCleaner());
          });
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

export const completePickingPartiallyFulfilled = (id, params, cb) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .completePickingPartiallyFulfilled(id)
    .then((response) => {
      if (response.status == 200) {
        dispatch(fetchFulfillmentList(params));
        dispatch(
          actions.changeOrderStatus({
            status: "Status Changed Successfully",
          })
        );

        cb && cb();
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

export const parkOrderPicking = (queryParams, params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .parkOrderPicking(queryParams)
    .then((response) => {
      if (response.status == 200 && !params?.__status) {
        if (!queryParams.suppressFulfillmentRefetch) {
          dispatch(fetchFulfillmentList(typeof params === "object" ? params : {}));
        }

        if (!queryParams.suppressNotification) {
          notification.success({ message: response.data.message });
        }
      }
      if (!!params?.__status) {
        requestFromServer
          .changeOrderStatus(params)
          .then((response) => {
            if (response.status == 200) {
              dispatch(fetchFulfillmentList({}));
              dispatch(
                actions.changeOrderStatus({
                  status: "Status Changed Successfully",
                })
              );
            }
          })
          .catch((error) => {
            dispatch(actions.catchError({ error, callType: callTypes.actions }));
            dispatch(actions.exceptionHandlerCleaner());
          });
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

export const cancelPausing = (queryParams, params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .cancelPausing(queryParams)
    .then((response) => {
      dispatch(fetchFulfillmentList(typeof params === "object" ? params : {}));
      notification.success({ message: response.data.message });
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};
export const parkOrderPacking = (queryParams, params, onHide, setLoading) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .parkOrderPacking(queryParams)
    .then((response) => {
      if (response.status == 200 && !params?.__status) {
        if (!queryParams?.suppressFulfillmentRefetch) {
          dispatch(fetchFulfillmentList(typeof params === "object" ? params : {}));
        }
        if (!queryParams?.suppressNotification) {
          notification.success({ message: response.data.message });
        }
        onHide && onHide();
        setLoading && setLoading(false);
      }
      if (!!params?.__status) {
        requestFromServer
          .changeOrderStatus(params)
          .then((response) => {
            if (response.status == 200) {
              dispatch(fetchFulfillmentList({}));
              dispatch(
                actions.changeOrderStatus({
                  status: "Status Changed Successfully",
                })
              );
              onHide && onHide();
            }
          })
          .catch((error) => {
            dispatch(actions.catchError({ error, callType: callTypes.actions }));
            dispatch(actions.exceptionHandlerCleaner());
          });
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
      setLoading && setLoading(false);
    });
};
// sale order delete from sale history
export const deleteSaleOrder = (id, queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .deleteOrder(id)
    .then((response) => {
      if (response.status == 200) {
        const { message } = response.data;
        dispatch(actions.deleteOrder({ id, message }));
        dispatch(fetchOrdersList({ ...queryParams }));
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

// switch sale order customer
export const switchSaleOrderCustomer = (orderId, customerId, cb) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .switchOrderCustomer(orderId, customerId)
    .then((response) => {
      if (response.status == 200) {
        const { entity } = response.data;
        dispatch(actions.copyOrder({ entity: entity }));
        cb && cb(orderId);
      }
    })
    .catch((error) => {
        error?.response?.data?.errors?.map && error.response.data.errors.map((error) => notification.error({ message: error }));
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

// sale order delete from fulfillment
export const deleteFulfillmentOrder = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .deleteOrder(id)
    .then((response) => {
      if (response.status == 200) {
        const { message } = response.data;
        dispatch(actions.deleteOrder({ id, message }));
        dispatch(fetchFulfillmentList({}));
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
    });
};

export const resetFilterSearches = () => (dispatch) => {
  dispatch(actions.resetFilterSearches());
};

export const findOrderByNo = (queryParams, setOrderLoading) => (dispatch) => {
  return requestFromServer
    .findOrderByNo(queryParams)
    .then((response) => {
      const { entities } = response.data;
      dispatch(actions.findOrderByNo({ entities }));
      setOrderLoading && setOrderLoading(false);
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      setOrderLoading && setOrderLoading(false);
    });
};

//select order no to filter by order no
export const setOrders = (orders) => (dispatch) => {
  dispatch(actions.findOrderByNo({ orders }));
};

//search customer to create order
export const searchCustomers = (queryParams, view) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .searchCustomers(queryParams)
    .then((response) => {
      const { entities } = response.data;
      dispatch(actions.customersSearched({ entities, view }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

//search customer by name
export const findCustomerByName = (queryParams) => (dispatch) => {
  return requestFromServer
    .findCustomerByName(queryParams)
    .then((response) => {
      const { entities } = response.data;
      dispatch(actions.findCustomerByName({ entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const sendEmail = (email) => (dispatch) => {
  return requestFromServer
    .sendEmail(email)
    .then(({ data }) => {
      dispatch(actions.updateMessage({ type: "success", message: data.message }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const startActionLoading = (isLoading) => (dispatch) => {
  dispatch(actions.startActionLoading({ isLoading }));
};

export const setStatusBack = (orderId, status) => (dispatch) => {
  dispatch(actions.setStatusBack({ orderId, status }));
};

export const validateShippingDetail = (shippingDetail) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  return requestFromServer
    .validateShippingDetail(shippingDetail)
    .then((response) => {
      const message = "Shipping detail is save successfully!";
      dispatch(actions.validateShippingDetail({ message, shippingDetail: shippingDetail.shipping_detail }));
    })
    .catch((error) => {
      error.clientMessage = "Shipping detail contain errors";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const bulkExecuteOrders = (orderIds, params, options = {}) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  dispatch(actions.startBlukExecutingActionLoading());
  return requestFromServer
    .bulkExecuteSaleOrder(orderIds, options)
    .then((response) => {
      if (response.status == 200) {
        dispatch(fetchFulfillmentList(params));
        dispatch(
          actions.changeOrderStatus({
            status: response?.data?.message || "Status Changed Successfully",
          })
        );
        dispatch(actions.endBlukExecutingActionLoading());
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
      dispatch(actions.endBlukExecutingActionLoading());
    });
};

export const bulkCompletePickingOrders = (orderIds, removeUnpicked, params, cb) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.actions }));
  dispatch(actions.startBlukExecutingActionLoading());
  const fulfillmentFilter = JSON.parse(localStorage.getItem("fulfillment_search_filter"));
  const savedStatuses = fulfillmentFilter?.advance_filters?.statuses;
  const effectiveParams = { ...params };
  if (savedStatuses?.length) {
    effectiveParams.statuses = savedStatuses.map((s) => s.value).join(",");
  }
  return requestFromServer
    .bulkCompletePickingSaleOrder(orderIds, removeUnpicked)
    .then((response) => {
      if (response.status == 200) {
        dispatch(fetchFulfillmentList(effectiveParams));
        dispatch(
          actions.changeOrderStatus({
            status: response?.data?.message || "Invoice updated successfully",
          })
        );
        dispatch(actions.endBlukExecutingActionLoading());

        cb && cb();
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.actions }));
      dispatch(actions.exceptionHandlerCleaner());
      dispatch(actions.endBlukExecutingActionLoading());
    });
};

export const cardVerificationFinish = () => (dispatch) => {
  dispatch(actions.cardVerificationFinish());
};

export const createQuickCustomer = (customer, saleOrderValues, cb, fieldName) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.modalActions }));
  return requestFromServer
    .createQuickCustomer(customer)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(actions.quickCustomerCreated({ message, entity }));
      !!cb && cb(saleOrderValues, entity.id, fieldName);
    })
    .catch((error) => {
      if (error?.response && error?.response.data) {
        dispatch(
          actions.updateMessage({
            type: "modalError",
            message: [error.response.data.message, ...error.response.data.errors],
          })
        );
      } else {
        dispatch(actions.catchError({ error, callType: callTypes.modalActions }));
      }
    });
};

export const fetchOrderProducts = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOptimizedProductsForSale(queryParams)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.orderProductsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const removeUnmountDate = () => (dispatch) => {
  dispatch(actions.removeUnmountDate());
};
export const removeSelectedCustomerHistory = () => (dispatch) => {
  dispatch(actions.removeSelectedCustomerHistory());
};

export const removeSaleCustomer = (customer) => (dispatch) => {
  dispatch(actions.removeSaleCustomer(customer));
};

export const setCurrentOrder = (order) => (dispatch) => {
  dispatch(actions.setCurrentOrder(order));
};

export const setCustomer = (customer) => (dispatch) => {
  dispatch(actions.setCustomer(customer));
};
export const handleLoading = (isLoading) => (dispatch) => {
  dispatch(actions.handleLoading(isLoading));
}
export const handleShowDeliverySchedule = (showSchedule) => (dispatch) => {
  dispatch(actions.handleShowDeliverySchedule(showSchedule));
}
export const handleSetInitialRoute = (route) => (dispatch) => {
  dispatch(actions.handleSetInitialRoute(route));
}
